import { render, staticRenderFns } from "./Transportcode.vue?vue&type=template&id=53866602"
import script from "./Transportcode.vue?vue&type=script&lang=js"
export * from "./Transportcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports